document.addEventListener('DOMContentLoaded', function () {
	const accordions = document.querySelectorAll('.js-accordion');

	accordions.forEach(function (accordion) {
		const target = accordion.querySelector('.js-accordion-target');

		// 初期状態を閉じる
		target.style.overflow = 'hidden';
		target.style.maxHeight = '0';
		target.style.height = '0';
		target.style.marginBottom = '0';
		target.style.transition = 'max-height 0.4s ease, height 0.4s ease, opacity 0.4s ease, margin-bottom 0.4s ease';
		target.style.opacity = '0';

		accordion.style.cursor = 'pointer';
		accordion.style.userSelect = 'none';

		accordion.addEventListener('click', function () {
			const isOpen = accordion.classList.contains('is-open');

			if (isOpen) {
				// 閉じる
				target.style.maxHeight = '0';
				target.style.height = '0';
				target.style.marginBottom = '0';
				target.style.opacity = '0';
				accordion.classList.remove('is-open');
			} else {
				// 開く
				target.style.maxHeight = target.scrollHeight + 'px';
				target.style.height = target.scrollHeight + 'px';
				target.style.marginBottom = ''; // CSSの元の値に戻す
				target.style.opacity = '1';
				accordion.classList.add('is-open');
			}
		});
	});
});
